import * as types from './mutation-types.js'
import * as middleware from './middleware'
import * as sideEffects from './side-effects'

const actions = {
  // PODCAST_DOWNLOADS
  requestPodcastDownloads: (context, { podcastId, options }) => {
    middleware.fetchPodcastDownloads(context)(
      { podcastId, options },
      actions.setPodcastDownloads,
      actions.setPodcastDownloadsError
    )
    context.commit(
      types.REQUEST_PODCAST_DOWNLOADS,
      { podcastId, options }
    )
  },
  setPodcastDownloads: (context, { podcastId, options, response }) => {
    context.commit(
      types.SET_PODCAST_DOWNLOADS,
      { podcastId, options, response }
    )
  },
  setPodcastDownloadsError: (context, { podcastId, options, error }) => {
    sideEffects.setPodcastDownloadsError({ podcastId, error })
    context.commit(
      types.SET_PODCAST_DOWNLOADS_ERROR,
      { podcastId, options, error }
    )
  },

  // EPISODE_DOWNLOADS
  requestEpisodeDownloads: (context, { episodeId, options }) => {
    middleware.fetchEpisodeDownloads(context)(
      { episodeId, options },
      actions.setEpisodeDownloads,
      actions.setEpisodeDownloadsError
    )
    context.commit(
      types.REQUEST_EPISODE_DOWNLOADS,
      { episodeId, options }
    )
  },
  setEpisodeDownloads: (context, { episodeId, options, response }) => {
    context.commit(
      types.SET_EPISODE_DOWNLOADS,
      { episodeId, options, response }
    )
  },
  setEpisodeDownloadsError: (context, { episodeId, options, error }) => {
    sideEffects.setEpisodeDownloadsError({ episodeId, error })
    context.commit(
      types.SET_EPISODE_DOWNLOADS_ERROR,
      { episodeId, options, error }
    )
  }
}

export default actions
